import { createClient } from '@supabase/supabase-js';
import { config } from '../config';

/**
 * Klien Supabase — HANYA untuk identitas: masuk, memulihkan sesi, menyegarkan token, keluar.
 * TIDAK dipakai untuk data bisnis; itu lewat Workforce API. Pola yang sama dengan `apps/web`.
 *
 * Ketiga opsi di bawah menentukan apakah aplikasi ini layak dipakai sepanjang shift:
 *
 * - `persistSession` — sesi bertahan setelah layar dimuat ulang. Tanpa ini, kurir yang tidak
 *   sengaja menutup tab harus masuk lagi di tengah pengiriman.
 * - `autoRefreshToken` — access token Supabase berumur pendek (bawaan satu jam). Tanpa ini,
 *   setiap permintaan setelah satu jam menjadi 401, dan layarnya tidak akan menjelaskan kenapa.
 * - `detectSessionInUrl` — dibutuhkan tautan email (pemulihan kata sandi) yang membawa token di
 *   URL; Supabase memprosesnya lalu membersihkan URL-nya.
 */
export const supabase = createClient(config.supabaseUrl, config.supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'implicit',
  },
});
